import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth.service';
import { LocalStorageService } from '../services/local-storage.service';
import { LogoutService } from '../services/logout/logout.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(
    public authService: AuthService,
    private logoutService: LogoutService,
    private localStorage: LocalStorageService
  ) { }

  ngOnInit(): void {
  }

  schoolDisplayName(): string {
    return this.localStorage.getSchoolDisplayName() || environment.schoolName;
  }

  logoutUser(event: Event): void {
    event.stopPropagation();
    this.logoutService.logoutUser();
  }

}
